import { useSizeGuide } from "./use-size-guide";
import { SizeGuideHeading } from "./size-guide-heading";
import { MeasurementStep } from "./measurement-step";
import { SizeGuideTableWrapper } from "./size-guide-table-wrapper";
import { SizeGuideFooter } from "./size-guide-footer";
import { MeasuringInstructions } from "./measuring-instructions";
import { useTranslate } from "@made-people/grease-translations";

export const SwimwearCharts = () => {
  const sizeGuide = useSizeGuide();
  const translate = useTranslate();
  if (!sizeGuide) return null;

  if (!sizeGuide.swimBottomUpdatedTable) {
    return null;
  }

  return (
    <>
      <MeasuringInstructions />
      <SizeGuideHeading title={translate("Size_Guide_Swimwear_Title")}>
        <MeasurementStep
          number={1}
          text={translate("Size_Guide_Swimwear_How_To_Measure_Step_1")}
        />
        <MeasurementStep
          number={2}
          text={translate("Size_Guide_Swimwear_How_To_Measure_Step_2")}
        />
        <MeasurementStep
          number={3}
          text={translate("Size_Guide_Swimwear_How_To_Measure_Step_3")}
        />
      </SizeGuideHeading>

      {sizeGuide.brasBandTable && (
        <SizeGuideTableWrapper
          tableData={sizeGuide.brasBandTable}
          icon={sizeGuide.bandTableIcon}
          title={translate("Size_Guide_Band_Size_Title")}
        />
      )}

      {sizeGuide.brasCupTable && (
        <SizeGuideTableWrapper
          tableData={sizeGuide.brasCupTable}
          icon={sizeGuide.cupTableIcon}
          title={translate("Size_Guide_Cup_Size_Title")}
        />
      )}
      <SizeGuideTableWrapper
        title={translate("Size_Guide_Swimsuits_Title")}
        tableData={sizeGuide.swimBottomUpdatedTable}
      />

      <SizeGuideFooter />
    </>
  );
};
